import Util from "./Util.js";
import { gsap } from "./Util.js";

class Slider extends Util {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.product();
  }

  product() {
    if (document.querySelector(".swiper-product")) {
      let target = document.querySelectorAll(".swiper-product .swiper-slide"),
        current = document.querySelector(".pagination .current"),
        total = document.querySelector(".pagination .total");

      for (let i = 0; i < target.length; i++) {
        let num = i + 1,
          numElement = document.createElement("i");
        numElement.textContent = num.toString().padStart(2, "0");
        current.appendChild(numElement);
        if (i === 0) {
          gsap.set(numElement, {
            transform: "translateX(0) translateY(0) translateZ(0)",
          });
        }
      }

      total.textContent = target.length.toString().padStart(2, "0");

      let swiperProductThumb = null,
        swiperProduct = null;

      if (document.querySelector(".swiper-product").classList.contains("horizontal")) {
        swiperProductThumb = new Swiper(".swiper-product-thumb", {
          spaceBetween: 14,
          slidesPerView: 6,
          speed: 800,
          allowTouchMove: true,
          direction: "vertical",
          navigation: {
            nextEl: ".swiper-button-next-thumb",
            prevEl: ".swiper-button-prev-thumb",
          },
          //   loop: true,
        });

        swiperProduct = new Swiper(".swiper-product", {
          speed: 800,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: swiperProductThumb,
          },
        });
      } else {
        swiperProductThumb = new Swiper(".swiper-product-thumb", {
          spaceBetween: 14,
          slidesPerView: 6,
          speed: 800,
          allowTouchMove: true,
          navigation: {
            nextEl: ".swiper-button-next-thumb",
            prevEl: ".swiper-button-prev-thumb",
          },
          //   loop: true,
        });

        swiperProduct = new Swiper(".swiper-product", {
          speed: 800,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: swiperProductThumb,
          },
        });
      }
      swiperProduct.on("slideChangeTransitionStart", function (el) {
        gsap.set(current.querySelectorAll("i")[swiperProduct.activeIndex], {
          transform: "translateX(0) translateY(100%) translateZ(0)",
        });

        gsap.to(current.querySelectorAll("i")[swiperProduct.previousIndex], {
          transform: "translateX(0) translateY(-100%) translateZ(0)",
          duration: 0.6,
          overwrite: true,
        });

        gsap.to(current.querySelectorAll("i")[swiperProduct.activeIndex], {
          transform: "translateX(0) translateY(0) translateZ(0)",
          duration: 0.8,
          overwrite: true,
        });
      });
    }

    // if (document.querySelector(".swiper-items") && this.website.isDesktop) {
    //   const swiperItems = new Swiper(".swiper-items", {
    //     speed: 800,
    //     spaceBetween: 20,
    //     slidesPerView: 3.7,
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //   });
    // }
  }
}

export default Slider;
